module.exports = __webpack_public_path__ + "img/3.d6f2b904.png";